<template>
  <div class="wrapper">
    <div
      class="page-header header-filter"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item md-size-100 text-center">
            <h1 class="title">404</h1>
            <h2 class="description">{{ message }}</h2>
            <md-button href="/" class="md-danger">Go back to home</md-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Mixins from '@/plugins/basicMixins';

export default {
  mixins: [Mixins.HeaderImage],
  bodyClass: 'error-page',
  props: {
    message: {
      type: String,
      default: 'Page not found',
    },
  },
  data() {
    return {
      image: require('@/assets/img/404.jpg'),
    };
  },
};
</script>

<style lang="scss"></style>
